import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardContent, Box, Stack } from "@mui/material";

import Audio from "components/audioPlayer/Audio";
import TrackInfo from "components/audioPlayer/TrackInfo";
import PlayPauseButton from "components/audioPlayer/PlayPauseButton";
import TimeDisplay from "components/audioPlayer/TimeDisplay";
import ProgressSlider from "components/audioPlayer/ProgressSlider";
import VolumeControl from "components/audioPlayer/VolumeControl";

const AudioPlayer = () => {
  const { url } = useSelector((state) => state.audio);
  const [position, setPosition] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(80);

  const handleTimeUpdate = (e) => {
    setPosition(e.target.currentTime);
  };

  const handleLoadedMetadata = (e) => {
    setDuration(e.target.duration);
  };

  const handleSliderChange = (event, newValue) => {
    setPosition(newValue);
    const audio = document.querySelector("audio");
    if (audio) {
      audio.currentTime = newValue;
    }
  };

  const handleVolumeChange = (event, newValue) => {
    setVolume(newValue);
    const audio = document.querySelector("audio");
    if (audio) {
      audio.volume = newValue / 100;
    }
  };

  return (
    <Stack>
      <Audio
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        setPosition={setPosition}
      />

      {/* <TrackInfo /> */}

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <TimeDisplay time={position} />

        <ProgressSlider
          position={position}
          duration={duration}
          onChange={handleSliderChange}
          disabled={!url}
        />

        <TimeDisplay time={duration} />
      </Box>

      {/* <VolumeControl volume={volume} onChange={handleVolumeChange} /> */}
    </Stack>
  );
};

export default AudioPlayer;
